import React, { Component } from "react";

import { thumb, thumbSelected, preview } from "./ReferenceImagesModal.css";

export class ReferenceImagesModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedThumbIndex: 0
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.exampleUrls !== this.props.exampleUrls) {
      this.setState({selectedThumbIndex: 0});
    }
  }

  render() {
    const { exampleUrls } = this.props;
    const { selectedThumbIndex } = this.state;

    if (!exampleUrls) {
      return null;
    }

    return (
      <div
        className="modal fade"
        id="referenceImagesModal"
        tabIndex={-1}
        role="dialog"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              If the image is not displayed properly, please click <a href={exampleUrls[selectedThumbIndex]} target="_blank">here</a>.
              <a href={exampleUrls[selectedThumbIndex]} target="_blank"><div style={{ backgroundImage: `url(${exampleUrls[selectedThumbIndex]})` }} className={`${preview}`}></div></a>
              {exampleUrls.map((exampleUrl, index) => (
                <React.Fragment key={exampleUrl + index}>
                  <div
                    className={`${thumb} ${
                      selectedThumbIndex === index ? thumbSelected : ""
                    }`}
                    style={{ backgroundImage: `url(${exampleUrl})` }}
                    onClick={() => this.setState({selectedThumbIndex: index})}
                  />{" "}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ReferenceImagesModal.js